import { Box, Button, Drawer } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { theme } from "../Themes/Theme";
import SideBar from "./SideBar";

interface SadeBarMobileProps {
  open: boolean;
  handleClose: () => void;
  mode: boolean;
  setMode: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SideBarMobile = ({
  open,
  handleClose,
  mode,
  setMode,
}: SadeBarMobileProps) => {
  let location = useLocation();

  useEffect(() => {
    handleClose();
  }, [location.pathname, mode]);

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          backgroundColor: theme(mode).palette.background.default,
          paddingTop:'1em'
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top:"0em",
          right:0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          zIndex: 1300,
        }}
      >
        <Tooltip title="close menu">

        <Button sx={{ fontSize: "2rem" }} onClick={handleClose}>
          {"<<"}
        </Button>
        </Tooltip>
      </Box>
      <SideBar mode={mode} setMode={setMode} />
    </Drawer>
  );
};
